import React, { useState, useEffect } from 'react';
import '../style/Stories.css';

const LEFT_CLICK_ZONE = 0.5;
const RIGHT_CLICK_ZONE = 0.5;

const Stories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentStory, setCurrentStory] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const response = await fetch('https://leoleveque.net/api/stories');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setStories(data);
      } catch (error) {
        console.error('Error fetching stories:', error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchStories();
  }, []);

  const openPopup = (story) => {
    setCurrentStory(story);
    setCurrentImageIndex(0);
  };

  const closePopup = () => {
    setCurrentStory(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => {
      const newIndex = (prevIndex + 1) % currentStory.images.length;
      return newIndex;
    });
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
    const imageWidth = e.currentTarget.offsetWidth;
    const clickX = e.nativeEvent.offsetX;
    if (clickX < (imageWidth * LEFT_CLICK_ZONE)) {
      setCurrentImageIndex(prevIndex => {
        const newIndex = (prevIndex - 1 + currentStory.images.length) % currentStory.images.length;
        return newIndex;
      });
    } else if (clickX > (imageWidth * RIGHT_CLICK_ZONE)) {
      nextImage();
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  if (error) {
    return <p>Error loading stories. Please try again later.</p>;
  }

  return (
    <div className="stories-container">
      {stories.map((story) => (
        <div
          key={story.id}
          className="story-item"
          onClick={() => openPopup(story)}
        >
          <div className="story-image-container">
            <img src={`${story.img_src}`} alt={story.title} className="story-image" />
          </div>
          <div className="story-title">{story.title}</div>
        </div>
      ))}

      {currentStory && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={`${currentStory.images[currentImageIndex]}`}
              alt={currentStory.title}
              className="popup-image"
              onClick={handleImageClick}
            />
            <div className="popup-indicator">
              <div
                className="progress-bar"
                style={{ width: `${((currentImageIndex + 1) / currentStory.images.length) * 100}%` }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stories;
